import { action } from 'typesafe-actions';
import { EnquiresActionTypes, DownloadEnquiryCombinedFilePayload } from 'types';

export const fetchEnquiryHistory = (request?: any) =>
  action(EnquiresActionTypes.FETCH_ENQUIRY_HISTORY, request);

export const fetchEnquiryHistorySuccess = (data: any) =>
  action(EnquiresActionTypes.FETCH_ENQUIRY_HISTORY_SUCCESS, data);

export const fetchEnquiryHistoryFailure = (error: any) =>
  action(EnquiresActionTypes.FETCH_ENQUIRY_HISTORY_FAILURE, error);

export const fetchEnquiryById = (request?: any) =>
  action(EnquiresActionTypes.FETCH_ENQUIRY_BYID, request);

export const fetchEnquirySuccess = (data: any) =>
  action(EnquiresActionTypes.FETCH_ENQUIRY_BYID_SUCCESS, data);

export const fetchEnquiryFailure = (error: any) =>
  action(EnquiresActionTypes.FETCH_ENQUIRY_BYID_FAILURE, error);

export const fetchResetLodgeEnquiry = () =>
  action(EnquiresActionTypes.RESET_LODGE_ENQUIRY_STATE);

export const fetchDesignActivity = (data: any) =>
  action(EnquiresActionTypes.FETCH_ENQUIRY_ACT_DESIGN, data);

export const fetchExcavationActivity = (data: any) =>
  action(EnquiresActionTypes.FETCH_ENQUIRY_ACT_EXCAVATE, data);

export const setEnquirySearchFilter = (data: any) =>
  action(EnquiresActionTypes.SET_ENQUIRY_SEARCH_FILTER, data);

export const updateEnquiryById = (request?: any) =>
  action(EnquiresActionTypes.UPDATE_ENQUIRY_BYID, request);

export const updateEnquiryByIdSuccess = (data: any) =>
  action(EnquiresActionTypes.UPDATE_ENQUIRY_BYID_SUCCESS, data);

export const updateEnquiryByIdFailure = (data: any) =>
  action(EnquiresActionTypes.UPDATE_ENQUIRY_BYID_FAILURE, data);

export const resetEnquiryShape = () =>
  action(EnquiresActionTypes.RESET_ENQUIRY_SHAPE);

export const setForwardEnquiryIsListView = (data: boolean) =>
  action(EnquiresActionTypes.SET_FORWARD_ENQUIRY_IS_LIST_VIEW, data);

export const setForwardEnquiryExternalId = (data: number) =>
  action(EnquiresActionTypes.SET_FORWARD_ENQUIRY_EXTERNAL_ID, data);

export const setForwardEnquiryDateRangeText = (data: string) =>
  action(EnquiresActionTypes.SET_FORWARD_ENQUIRY_DATE_RANGE_TEXT, data);

export const clearAllEnquiryState = () =>
  action(EnquiresActionTypes.CLEAR_ALL_ENQUIRY_STATE);

export const clearEnquiries = () => action(EnquiresActionTypes.CLEAR_ENQUIRIES);

export const connectWebsocketForEnquiry = (id: number) =>
  action(EnquiresActionTypes.CONNECT_WEBSOCKET_FOR_ENQUIRY, id);

export const connectWebsocketForDownloadFile = (payload: any) =>
  action(EnquiresActionTypes.CONNECT_WEBSOCKET_FOR_DOWNLOAD_FILE, payload);

export const updateEnquiryReferral = (data: any) =>
  action(EnquiresActionTypes.UPDATE_ENQUIRY_REFERRAL, data);

export const downloadEnquiryCombinedFileStart = (
  payload: DownloadEnquiryCombinedFilePayload
) => action(EnquiresActionTypes.DOWNLOAD_ENQUIRY_COMBINED_FILE_START, payload);

export const downloadEnquiryCombinedFileSuccess = (data: any) =>
  action(EnquiresActionTypes.DOWNLOAD_ENQUIRY_COMBINED_FILE_SUCCESS, data);

export const downloadEnquiryCombinedFileFailure = (data: any) =>
  action(EnquiresActionTypes.DOWNLOAD_ENQUIRY_COMBINED_FILE_FAILURE, data);

export const resetDownloadEnquiryCombinedFile = (data: any) =>
  action(EnquiresActionTypes.RESET_DOWNLOAD_ENQUIRY_COMBINED_FILE, data);

export const getAttachmentPreviewUrlStart = (request?: any) =>
  action(EnquiresActionTypes.GET_ATTACHMENT_PREVIEW_URL_START, request);

export const getAttachmentPreviewUrlSuccess = (data: any) =>
  action(EnquiresActionTypes.GET_ATTACHMENT_PREVIEW_URL_SUCCESS, data);

export const getAttachmentPreviewUrlFailure = (error: any) =>
  action(EnquiresActionTypes.GET_ATTACHMENT_PREVIEW_URL_FAILURE, error);

export const resetAttachmentPreviewUrl = () =>
  action(EnquiresActionTypes.RESET_ATTACHMENT_PREVIEW_URL);

export const getAttachmentDownloadUrlStart = (request?: any) =>
  action(EnquiresActionTypes.GET_ATTACHMENT_DOWNLOAD_URL_START, request);

export const getAttachmentDownloadUrlSuccess = (data: any) =>
  action(EnquiresActionTypes.GET_ATTACHMENT_DOWNLOAD_URL_SUCCESS, data);

export const getAttachmentDownloadUrlFailure = (error: any) =>
  action(EnquiresActionTypes.GET_ATTACHMENT_DOWNLOAD_URL_FAILURE, error);

export const resetAttachmentDownloadUrl = () =>
  action(EnquiresActionTypes.RESET_ATTACHMENT_DOWNLOAD_URL);

export const getEnquiryConfirmationPDFDownloadUrlStart = (payload: any) =>
  action(
    EnquiresActionTypes.GET_ENQUIRY_CONFIRMATION_PDF_DOWNLOAD_URL_START,
    payload
  );

export const getEnquiryConfirmationPDFDownloadUrlSuccess = (data: any) =>
  action(
    EnquiresActionTypes.GET_ENQUIRY_CONFIRMATION_PDF_DOWNLOAD_URL_SUCCESS,
    data
  );

export const getEnquiryConfirmationPDFDownloadUrlFailure = (data: any) =>
  action(
    EnquiresActionTypes.GET_ENQUIRY_CONFIRMATION_PDF_DOWNLOAD_URL_FAILURE,
    data
  );

export const resetEnquiryConfirmationPDFDownloadUrl = () =>
  action(EnquiresActionTypes.RESET_ENQUIRY_CONFIRMATION_PDF_DOWNLOAD_URL);

export const getDownloadAdvancedOptionsStart = (data: any) =>
  action(EnquiresActionTypes.GET_DOWNLOAD_ADVANCED_OPTIONS_START, data);

export const getDownloadAdvancedOptionsSuccess = (payload: any) =>
  action(EnquiresActionTypes.GET_DOWNLOAD_ADVANCED_OPTIONS_SUCCESS, payload);

export const getDownloadAdvancedOptionsFailure = () =>
  action(EnquiresActionTypes.GET_DOWNLOAD_ADVANCED_OPTIONS_FAILURE);

export const resetDownloadAdvancedOptions = () =>
  action(EnquiresActionTypes.RESET_DOWNLOAD_ADVANCED_OPTIONS);
